<div class="grid gap-6 mb-5">
  <xena-autocomplete idProperty="id" valueLabelProperty="email" listLabelProperty="email" [datasource]="usersDatasource"
    (valueChange)="onUserChange($event)">
    <xena-icon slot="suffix" name="fas-search"></xena-icon>
  </xena-autocomplete>
</div>
<xena-table>
  <xena-column i18n="@@support-user-membership-fiscal-id">Fiscal id</xena-column>
  <xena-column i18n="@@support-user-membership-fiscal-name">Fiscal name</xena-column>
  <xena-column i18n="@@support-user-membership-apps">Apps</xena-column>
  <xena-column i18n="@@support-user-membership-security-groups">Security groups</xena-column>
  <xena-row *ngFor="let user of userMemberships">
    <xena-cell>{{user.fiscalSetupId}}</xena-cell>
    <xena-cell>{{user.fiscalSetupName}}</xena-cell>
    <xena-cell>
      <div *ngFor="let app of user.installedAppNames">{{app}}</div>
    </xena-cell>
    <xena-cell>
      <div *ngFor="let sg of user.securityGroups">{{sg}}</div>
    </xena-cell>
  </xena-row>
</xena-table>